<div class="container-wrapper add-permit-wrapper">
    <form [formGroup]="addPermitForm" (submit)="onSubmit()" #formDirective="ngForm" >
    <div class="row">
        <div class="col-6">
            <mat-form-field  class="mat-date-pick">
                <mat-label>State</mat-label>
                <mat-select formControlName="stateId" required>
                  <!-- <mat-option>--</mat-option> -->
                  <mat-option  [value]="state.id"  pattern="^[a-zA-Z0-9\-_]{0,40}$"*ngFor="let state of states">{{state.state}}</mat-option>
                </mat-select>
                <mat-error *ngIf="addPermitForm.get('stateId').hasError('required')">
                  Please enter state
                </mat-error>  
              </mat-form-field>
        </div>  
        <div class="col-6">            
      <mat-form-field  class="mat-date-pick">
        <mat-label>Plate No.</mat-label>
        <input matInput formControlName="plateNo" pattern="^[a-zA-Z0-9\-_]{0,40}$" required/>
        <mat-error *ngIf="addPermitForm.get('plateNo').hasError('required')">
          Please enter plate number
        </mat-error> 
        <mat-error *ngIf="!addPermitForm.get('plateNo').hasError('required') && addPermitForm.get('plateNo').hasError('pattern')">
          Plate.No. should be alphanumeric without spaces.
        </mat-error> 
     </mat-form-field>
        </div>
    </div>
      <div class="row">
       <div class="col-6">
          <mat-form-field  class="mat-date-pick">
            <mat-label>Month</mat-label>
            <mat-select formControlName="month" required>
              <!-- <mat-option>--</mat-option> -->
              <mat-option  [value]="month.val" *ngFor="let month of months">{{month.name}}</mat-option>
            </mat-select>
            <mat-error *ngIf="addPermitForm.get('month').hasError('required')">
              Please enter month
            </mat-error>  
          </mat-form-field>
       </div>
       <div class="col-6">
          <mat-form-field  class="mat-date-pick">
            <mat-label>Year</mat-label>
            <mat-select formControlName="year" required>
              <!-- <mat-option>--</mat-option> -->
              <mat-option  [value]="year" *ngFor="let year of years">{{year}}</mat-option>
            </mat-select>
            <mat-error *ngIf="addPermitForm.get('year').hasError('required')">
              Please enter year
            </mat-error>  
          </mat-form-field>
       </div>
      </div>
      <button mat-button class="button-primary" [disabled]="addPermitForm.invalid || btndisabled" color="vov-ui-primary">Submit</button>
      <span ><a style="padding: 22px;color: #6A0721;font-weight: bold;text-decoration: none;cursor: pointer;"  color="vov-ui-primary" (click)="reset()">Reset</a></span> 
      </form>
   </div>